import { List } from "./List/index";

export default {
  List,
};
